import { OnInit, Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { takeUntil } from 'rxjs/operators';
import { TuiSizeL, TuiSizeS, TuiSizeXL, TuiSizeXXL } from '@taiga-ui/core';
import { BreakpointObserverHelperService } from '@src/core/services';
import { ScreenDimension, ScreenTypes } from '@src/models';

import { BaseComponent } from './base.component';

@Component({
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export abstract class BaseResizableComponent extends BaseComponent implements OnInit {
  // TODO: refactoring - #11127
  screenType: ScreenTypes = 'extra-large';
  screenDimension: ScreenDimension = 'desktop';

  protected readonly breakpointObserver = inject(BreakpointObserver);
  protected readonly breakpointObserverHelperService = inject(BreakpointObserverHelperService);

  // TODO: пройтись по всем компонентам и подключить super.ngOnInit()
  ngOnInit(): void {
    this.breakpointObserver
      .observe(this.breakpointObserverHelperService.breakpointsSet)
      .pipe(takeUntil(this.destroyed$$))
      .subscribe((state: BreakpointState) => {
        this.screenType = this.breakpointObserverHelperService.getScreenType(state);

        this.screenDimension = this.breakpointObserverHelperService
          .getScreenTypesBiggerThanTarget('medium')
          .includes(this.screenType)
          ? 'desktop'
          : 'mobile';

        this.afterChangeScreenType();

        this.cdr.markForCheck();
      });
  }

  protected afterChangeScreenType() {
    // TBD
  }

  get screenTypesLargeSet(): ScreenTypes[] {
    return this.breakpointObserverHelperService.getScreenTypesBiggerThanTarget('large');
  }

  get tuiElementSmallSize(): TuiSizeS {
    return this.screenTypesLargeSet.includes(this.screenType) ? 'm' : 's';
  }

  get tuiElementMediumSize(): TuiSizeS {
    return this.screenTypesLargeSet.includes(this.screenType) ? 'm' : 's';
  }

  get tuiElementLargeSize(): TuiSizeL {
    return this.screenTypesLargeSet.includes(this.screenType) ? 'l' : 'm';
  }

  get tuiElementDoubleExtraLargeSize(): TuiSizeXXL | TuiSizeXL {
    return this.isLargeScreen ? 'xxl' : 'xl';
  }

  get isLargeScreen(): boolean {
    return this.breakpointObserverHelperService.getScreenTypesBiggerThanTarget('large').includes(this.screenType);
  }

  get isExtraLargeScreen(): boolean {
    return this.breakpointObserverHelperService.getScreenTypesBiggerThanTarget('extra-large').includes(this.screenType);
  }

  get isDoubleExtraLargeScreen(): boolean {
    return this.breakpointObserverHelperService
      .getScreenTypesBiggerThanTarget('double-extra-large')
      .includes(this.screenType);
  }

  get isMobile() {
    return this.screenDimension === 'mobile';
  }

  get isDesktop() {
    return this.screenDimension === 'desktop';
  }
}
